module.exports = __webpack_public_path__ + "static/media/YOUTUBE.9f93da28.jpg";